module.exports = __webpack_public_path__ + "img/6.aa81b4d4.png";